import React, { type FC } from 'react'

import {
  Flex,
  FlexItem,
  TEXT_VARIANT_SMALL_LIGHT,
  Text,
} from 'mailup-web-components'

import {
  STORE_KEY_LIST,
  fromUTCtoZoneFormatted,
  storeGet,
} from 'mailup-react-helpers'

import type {
  ActivityBounceType,
  ActivityEmailEventType,
} from 'Types/beRecipientsApi'

import ActivityDetails from 'Pages/RecipientsList/components/aside/activityStream/ActivityDetails'
import ActivityIcon from 'Pages/RecipientsList/components/aside/activityStream/ActivityIcon'
import ActivityTitle from 'Pages/RecipientsList/components/aside/activityStream/ActivityTitle'
import type { SearchResult } from 'Pages/RecipientsList/model'

interface ActivityStreamItemProps {
  recipient: SearchResult
  activity: {
    ActivityType: ActivityEmailEventType
    ActivityDate: string
    BounceType: ActivityBounceType
    sending: {
      Type?: 'Task' | 'Workflow'
    }
    message: {
      Id?: number
      Subject?: string
    }
  }
  channel: 'email' | 'sms'
}

const ActivityStreamItem: FC<ActivityStreamItemProps> = ({
  recipient,
  activity: { ActivityType, ActivityDate, sending, message, BounceType },
  channel,
}) => {
  const { TimeZoneCode } = storeGet(STORE_KEY_LIST)

  return (
    <Flex alignItems="flex-start" gap="16px" flexGrow={1}>
      <FlexItem flexBasis="20px">
        <ActivityIcon activityType={ActivityType} />
      </FlexItem>
      <Flex flexDirection="column" flexGrow={1} gap="4px">
        <ActivityTitle
          recipient={recipient}
          activityType={ActivityType}
          bounceType={BounceType}
          sending={sending}
          channel={channel}
        />
        <ActivityDetails
          recipient={recipient}
          activityType={ActivityType}
          message={message}
          sending={sending}
          channel={channel}
        />
      </Flex>
      <FlexItem>
        <Text variant={TEXT_VARIANT_SMALL_LIGHT}>
          {fromUTCtoZoneFormatted(
            ActivityDate,
            TimeZoneCode,
            'YYYY-MM-DD HH:mm',
          )}
        </Text>
      </FlexItem>
    </Flex>
  )
}

export default ActivityStreamItem
